document.addEventListener("DOMContentLoaded", function () {
    const modalOpenBtns = document.querySelectorAll("[data-modal]");
    const modalOvelayEls = document.querySelectorAll(".js-sl-modal-overlay");
    const modalCloseBtns = document.querySelectorAll(".js-sl-modal-close-btn");

    const showModal = (btn) => {
        btn.addEventListener("click", async (e) => {
            e.preventDefault();
            const parentCard = e.target.parentNode.parentNode.parentNode;
            const dataModal = btn.dataset.modal;
            const modalEl = document.querySelector(`#${dataModal}`);
            if (dataModal == 'sl-product-quick-view-modal') {
                const productUrl = btn.dataset.handle;
                const modalContentEl = modalEl.querySelector(".js-sl-modal-content");

                if (!productUrl) {
                    console.error("No data-handle found on button.");
                    return;
                }

                // Show loading message
                if (modalContentEl) {
                    modalContentEl.innerHTML = '<p class="text-center py-6">Loading product details...</p>';
                }
                try {
                    // Fetch product section HTML
                    const response = await fetch(productUrl);
                    if (!response.ok) throw new Error(`HTTP error! ${response.status}`);

                    const html = await response.text();

                    // Insert fetched HTML into modal content
                    if (modalContentEl) {
                        modalContentEl.innerHTML = html;
                    }
                    const ratingHTML = parentCard?.querySelector(".sl-product-card__rating").innerHTML;
                    // discount
                    let productcard = document.querySelector(".js-sl-modal-content .js-product-card")
                    applyDiscountCodeMethod(productcard)
                    // Variant json
                    updateMasterIds();
                    productcard.querySelector(".sl-product-rating").innerHTML = parentCard?.querySelector(".sl-product-card__rating").innerHTML
                    const selectElements = productcard.querySelectorAll('.sl-form__input--check');
                    selectElements.forEach((input) => {
                        input.addEventListener('change', function () {
                            updateMasterIds();
                            let productcard = document.querySelector(".js-sl-modal-content .js-product-card")
                            const productForm = document.querySelector(
                                `.js-sl-modal-content product-form`
                            );
                            const addButton = productForm.querySelector('[name="add"]');
                            const duplicateBuynow = productForm.querySelector(".js-buy-now-btn");
                            const addButtonText = productForm.querySelector('[name="add"] > span');
                            const oosbutton = productForm.querySelector('[name="add"] > .sold-out-message ');
                            if (window.currentSelectedVariant) {
                                let originalPrice = productcard.querySelector('.js-original-price');
                                let currentPrice = productcard.querySelector('.js-current-price');
                                let savingBadge = productcard.querySelector(".js-saving-bdge")
                                let selectedVariantJSON = window.currentSelectedVariant;
                                if (originalPrice) {
                                    if (selectedVariantJSON.compare_at_price != null) {
                                        originalPrice.innerHTML = theme.Currency.formatMoney(selectedVariantJSON.compare_at_price, theme.settings.moneyFormat)
                                        originalPrice.classList.remove('hidden')
                                    } else {
                                        originalPrice.innerHTML = theme.Currency.formatMoney(selectedVariantJSON.price, theme.settings.moneyFormat);
                                        originalPrice.classList.add('hidden')
                                    }
                                }
                                if (currentPrice) {
                                    currentPrice.innerHTML = theme.Currency.formatMoney(selectedVariantJSON.price, theme.settings.moneyFormat)
                                }
                                const input = productForm.querySelector('input[name="id"]');
                                input.value = window.currentSelectedVariant.id;
                                applyDiscountCodeMethod(productcard)
                                oosbutton.classList.add('hidden')
                                addButtonText.classList.remove('hidden')
                                addButton.removeAttribute("disabled");
                                duplicateBuynow.removeAttribute("disabled");
                                addButton.setAttribute(
                                    'onclick',
                                    `event.preventDefault();document.querySelector('ajax-cart').addToCart('${window.currentSelectedVariant.id}')`
                                );
                            } else {
                                duplicateBuynow.setAttribute("disabled", "disabled");
                                addButton.setAttribute("disabled", "disabled");
                                oosbutton.classList.remove('hidden')
                                addButtonText.classList.add('hidden')
                            }
                            productcard.querySelector(".sl-product-rating").innerHTML = parentCard?.querySelector(".sl-product-card__rating").innerHTML
                        })
                    })
                    const productcardBuynow = productcard.querySelector(".js-buy-now-btn");
                    if (productcardBuynow) {
                        productcardBuynow.addEventListener('click', function () {
                            productcard.querySelector(".shopify-payment-button").click();
                        })
                    }
                } catch (error) {
                    console.error("Error fetching product data:", error);
                    if (modalContentEl) {
                        modalContentEl.innerHTML = '<p class="text-center text-red-500 py-6">Error loading product details.</p>';
                    }
                }
            }
            modalEl.classList.add("is--active");
        })
    }

    function updateMasterIds() {
        let productcard = document.querySelector(".js-sl-modal-content .js-product-card")
        const variantData = JSON.parse(productcard.querySelector('[type="application/json"]').textContent);
        const fieldsets = Array.from(productcard.querySelectorAll("fieldset"));
        let selectedVariantOptions = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll("input")).find(
                (radio) => radio.checked
            ).value;
        });
        let currentVariant = variantData.find((variant) => {
            //   return variant.title === this.querySelector('select').value;
            return !variant.options
                .map((option, index) => {
                    return selectedVariantOptions[index] === option;
                })
                .includes(false);
        });
        window.currentSelectedVariant = currentVariant
        if (productcard.querySelector(':checked')) {
            const selectedOptionOneVariants = variantData.filter(
                (variant) => productcard.querySelector(':checked').value === variant.option1
            );
            const inputWrappers = [...productcard.querySelectorAll('.product-form__input')];
            inputWrappers.forEach((option, index) => {
                if (index === 0) return;
                const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
                const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
                const availableOptionInputsValue = selectedOptionOneVariants
                    .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
                    .map((variantOption) => variantOption[`option${index + 1}`]);
                optionInputs.forEach((input) => {
                    if (availableOptionInputsValue.includes(input.getAttribute('value'))) {
                        input.classList.remove('disabled');
                        input.disabled = false;
                    } else {
                        input.classList.add('disabled');
                        input.disabled = true;
                    }
                });
            });
        }
    }

    function initAddtocart(productcard) {

    }

    modalOpenBtns.forEach((btn) => {
        showModal(btn);
    });
    document.addEventListener(
        "ajaxSearchComplete",
        (e) => {
            document.querySelectorAll("[data-modal]").forEach((btn) => {
                showModal(btn);
            });
        },
        false,
    );
    modalOvelayEls.forEach((modalOvelayEl) => {
        modalOvelayEl.addEventListener("click", function (e) {
            const modalEl = this.closest(".js-sl-modal");
            modalEl.classList.remove("is--active");
        })
    });

    modalCloseBtns.forEach((modalCloseBtn) => {
        modalCloseBtn.addEventListener("click", function (e) {
            const modalEl = this.closest(".js-sl-modal");
            e.preventDefault();
            modalEl.classList.remove("is--active");
        })
    });
})